import { Outlet } from 'react-router-dom';
import { ClientHeader } from './ClientHeader';

export function ClientLayout() {
  return (
    <div className="flex h-screen flex-col overflow-hidden">
      {/* Header simplificado */}
      <ClientHeader />

      {/* Conteúdo principal - sem sidebar */}
      <main className="flex-1 overflow-y-auto bg-background p-6">
        <Outlet />
      </main>
    </div>
  );
}
